'use client';

import useBreadcrumbs from './useBreadcrumbs';
import { BreadcrumbsTrail, type BreadcrumbsTrailProps } from './BreadcrumbsTrail';

interface BreadcrumbsFromPathProps extends Pick<BreadcrumbsTrailProps, 'classNames'> {
  pageTitle?: string;
}

export const BreadcrumbsFromPath = ({ pageTitle, classNames }: BreadcrumbsFromPathProps) => {
  const { crumbs, schema } = useBreadcrumbs({ pageTitle });
  return <BreadcrumbsTrail crumbs={crumbs} schema={schema} classNames={classNames} />;
};
